import { useEffect, useState } from 'react'

interface GoBackButtonProps {
  onSelectCam: (i: number) => void
}

export default function GoBackButton({ onSelectCam }: GoBackButtonProps) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const id = requestAnimationFrame(() => setVisible(true))
    return () => cancelAnimationFrame(id)
  }, [])

  return (
    <button
      className="go-back-button"
      onClick={() => onSelectCam(1)}
      style={{
        position: 'fixed',
        bottom: '0',
        left: '50%',
        transform: `translate(-50%, ${visible ? '0' : '2rem'})`,
        opacity: visible ? 1 : 0,
        transition: 'transform 0.4s ease, opacity 0.4s ease',
        width: '100%',
        padding: '1.25rem',
        background: 'linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0))',
        color: 'white',
        border: 'none',
        fontSize: '2.95rem',
        fontFamily: "'Untitled Sans Light', sans-serif",
        fontWeight: 400,
        fontStyle: 'italic',
        cursor: 'pointer',
      }}
    >Wróć na środek
    </button>
  )
}
